'use es6';

var isTrue = function isTrue(v) {
  return v && v.toLowerCase() === 'true';
};

export var isSafeMode = function isSafeMode(options) {
  return options.safeMode || options.localStorage && isTrue(options.localStorage.getItem('HUB-HTTP_SAFE_MODE'));
};